export const locale = {
  lang: 'zh2',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡恭喜，您已经完成了配置过程!',
      'INDICACION':'为了使您的调查能够在配置的日期生效并准备就绪，您必须单击“激活调查”按钮',
      'CONFIRMAR':'激活调查',
      'CERRAR-CONFIRMAR':'停用调查',
      'IND_CONFIRM_JP': '在继续激活调查之前，有必要确认之前配置的信息',
      'BTN_CONFIRM_INFO': '确认信息',
      'IND_ESP_CONFIRM_JP':'一旦项目经理确认，我们将继续激活调查',
      'MOD_TIT_CONGR_CONF':'谢谢你的确认',
      'MOD_ESP_CONFIRM_JP':'我们只需要项目经理的批准，就可以继续进行调查激活',
      'MESSAGE5':'准备进行主动调查',
      'HISTORY_ACTIVATION_1': '上次激活/停用',
      'HISTORY_ACTIVATION_2': '激活历史:',
      'ESTATUS_SURVEY':{
        '0':'停用',
        '1':'激活',
        '2':'关闭',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>继续激活调查',
          // 'MESSAGE2':', 在文本框中以红色输入文本</span>',
          'MESSAGE1':'<span> 要继续激活调查，请在文本框中输入红色的文本 ',
          'MESSAGE2':'</span>',
          'SALIR': '取消',
          'VALIDAR': '确认',
          'ERRORNOMBREEMPRESA': '输入的文本与红色表示的文本不匹配',
          'SUCCES': '调查已激活',
          'CERRAR': '关',
          'SUCCES-DES': '调查已停用',
          'MESSAGE3':'<span>要继续停用调查，请在文本框中输入红色的文本 ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'当前调查已经有结果，您确定可以将其停用吗？',
          'MESSAGE6':'当前没有调查',
          'BTN-ACEPTAR': '接受',
          'BTN-CANCELAR': '取消',
          'BTN-OK': '确定',
          'HORAMINIMA': '无法确认通过电子邮件的通信，发送第一封电子邮件的日期（启动或第一次通知，视情况而定）必须晚于两小时，\n\n如有必要，请再次设置日期'
        },
      },
      'MODAL_CONFIRMACION': {
        'TITULO': '资料确认',
        'INFO_1': '我们通知您，在继续激活调查之前，您必须确认您的产品信息。 我们在下面提供贵公司和产品的详细信息',
        'INFO_2': '如果信息正确，请单击<b>确认</b>按钮，否则，请联系您的项目经理进行审核',
        'TABLA': {
          'TITULOS': {
            'clave': '字段名称',
            'valor': '当前值'
          },
          'CAMPOS': {
            'company_name': '公司名称',
            'short_name': '简称',
            'publication_name': '出版物名称',
            'company': '公司标志',
            'certificate': '证书标识',
            'foundation_year': '基础年',
            'fullTime_employees': '全职员工人数',
            'parcial_employees': '兼职合作者人数',
            'total_employees': '合作者总数',
            'sector': '部门',
            'sub_sector': '分界别',
            'rankig_type': '排名类型',
            'ranking_name': '排名名称',
            'name_RH': '人力资源经理姓名',
            'email_RH': '人力资源经理的电子邮件',
            'tel_RH': '人力资源经理的电话号码',
            'ext_RH': '人力资源经理扩展',
            'cel_RH': '人事经理手机号',
            'state': '状态',
            'multinational_group': '跨国集团名称',
            'country_application': '申请国家',
          }
        }
      }
    },
  }
};
